import { render, staticRenderFns } from "./chooseOnlineFilesDialog.vue?vue&type=template&id=f56d771a&scoped=true&"
import script from "./chooseOnlineFilesDialog.vue?vue&type=script&lang=js&"
export * from "./chooseOnlineFilesDialog.vue?vue&type=script&lang=js&"
import style0 from "./chooseOnlineFilesDialog.vue?vue&type=style&index=0&id=f56d771a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56d771a",
  null
  
)

export default component.exports